import { useIntl } from "react-intl";

import FormItem from "forms/fields/FormItem";
import type { FormControlType } from "types/formType";
import type { IFormInputs } from "types/uiSchema";
import { MultiSelect as UiMultiSelect } from "ui/MultiSelect/MultiSelect";
import { FormField } from "uiShadcn/form";

interface MultiSelectProps {
    control: FormControlType;
    uiData: IFormInputs;
}

export default function MultiSelect({ control, uiData }: Readonly<MultiSelectProps>) {
    const { formatMessage } = useIntl();
    const name = uiData["x-json-schema-reference-property"];
    const isRequired = uiData?.required?.includes("true");

    const dictionary = uiData["x-dictionary"] ?? [];

    if (!name || dictionary?.length === 0) return null;

    return (
        <FormField
            control={control}
            name={name}
            render={({ field }) => (
                <FormItem label={uiData.description} required={isRequired}>
                    <UiMultiSelect
                        options={dictionary}
                        onValueChange={field.onChange}
                        defaultValue={field.value}
                        placeholder={formatMessage({ id: "choose" })}
                        maxCount={3}
                        dataTestId={field.name}
                        required={isRequired}
                        ref={field.ref}
                    />
                </FormItem>
            )}
        />
    );
}
